import PackagesService from '../services/package.service';
import { Package } from './models/models';

export default {
  namespaced: true,
  state: {
    packageId: null,
  },
  mutations: {
    packageId(state, packageId) {
      state.packageId = packageId;
    },
  },
  actions: {
    init({ dispatch }) {
      dispatch('getProductPackages');
    },
    newProductPackage({ commit }) {
      Package.new()
        .then((packageEntry) => {
          commit('packageId', packageEntry.id);
        });
    },
    updateProductPackageProps({ state }, props) {
      Package.update({
        where: state.packageId,
        data: props,
      });
    },
    getProductPackages() {
      return PackagesService.getPackages()
        .then((res) => {
          Package.create({ data: res });
        });
    },
    suggestProductPackages(store, query) {
      return PackagesService.suggestPackages(query);
    },
    getProductPackage({ commit }, id) {
      return PackagesService.getPackage(id)
        .then((packageEntry) => {
          Package.insert({ data: [packageEntry] })
            .then(() => {
              commit('packageId', packageEntry.id);
            });
        });
    },
    createProductPackage({ getters }) {
      return PackagesService.createPackage(getters.productPackage);
    },
    updateProductPackage({ getters, dispatch }) {
      return PackagesService.updatePackage(getters.productPackage)
        .then((res) => {
          if (res.hasOwnProperty('package_id')) {
            dispatch('getProductPackage', res.package_id);
          }
          return res;
        });
    },
    deleteProductPackage({ getters }) {
      return PackagesService.deletePackage(getters.productPackage)
        .then((res) => {
          if (res.hasOwnProperty('package_id')) {
            Package.delete(res.package_id);
          }
          return res;
        });
    },
  },
  getters: {
    productPackages() {
      return Package.all();
    },
    productPackage(state) {
      if (!state.packageId) {
        return null;
      }
      return Package.query()
        .find(state.packageId);
    },
  },
};
